import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { shelfItemShape } from '@bibliocommons/bc-prop-types';

import ShelfActions from 'app/actions/ShelfActions';
import { selectShelvesForCurrentUser } from 'app/selectors/ShelfSelector';
import AddedToShelfWorkflow from './AddedToShelfWorkflow';

export class AddedToShelfWorkflowContainer extends React.PureComponent {
  render() {
    const { id, bib, shelfItem, closeWorkflow, shelfActions, view } = this.props;

    return (
      shelfItem && (
        <AddedToShelfWorkflow
          workflowId={id}
          bib={bib}
          shelfItem={shelfItem}
          handleClose={closeWorkflow}
          updateShelfItems={shelfActions.updateShelfItems}
          removeShelfItems={shelfActions.removeShelfItems}
          view={view}
        />
      )
    );
  }
}

AddedToShelfWorkflowContainer.propTypes = {
  id: PropTypes.string,
  bib: ImmutablePropTypes.map,
  shelfItem: shelfItemShape,
  closeWorkflow: PropTypes.func.isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired,
  view: PropTypes.string
};

AddedToShelfWorkflowContainer.displayName = 'ItemTransactionWorkflowContainer';

const mapStateToProps = (state, ownProps) => {
  const bib = state.getIn(['entities', 'bibs', ownProps.metadataId, 'briefInfo']);
  const shelfItem = selectShelvesForCurrentUser(state).get(ownProps.metadataId);

  return {
    bib,
    shelfItem
  };
};

const mapDispatchToProps = dispatch => ({
  shelfActions: bindActionCreators(ShelfActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(AddedToShelfWorkflowContainer);
